export default () => ({
  quickViewSwiper: null,

  init() {
    this.$nextTick(() => {
      this.initQuickViewSwiper();
    });
  },


  initQuickViewSwiper() {
    const swiperElement = document.querySelector('.quickView_media_gallery');
    this.quickViewSwiper = new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 10,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      pagination: {
        el: '.quickview-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
        nextEl: '.quickview.swiper-button-next',
        prevEl: '.quickview.swiper-button-prev',
      },
      breakpoints: {
        320: {
          spaceBetween: 5,
        },
        750: {
          spaceBetween: 10,
        },
      },
    });

    // Trigger variant change to sync slider with default selected variant
    this.$nextTick(() => {
      const variantSelector = document.querySelector(
        'quick-variant-selects, quick-variant-radios',
      );
      if (variantSelector) {
        variantSelector.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  },

  destroy() {
    if (this.quickViewSwiper) {
      this.quickViewSwiper.destroy();
      this.quickViewSwiper = null;
    }
  },
});
